document.addEventListener('DOMContentLoaded', function () {
  // Radio button toggle for One-time vs Subscribe & Save (Namespaced for All Products)
  var purchaseRadios = document.querySelectorAll('.ap-purchase-list input[type="radio"], .btm1_list input[type="radio"]');
  purchaseRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      var targetId = this.getAttribute('data-target');
      var price = this.getAttribute('data-price');
      var productId = this.getAttribute('data-product-id');
      var val = this.value;
      var target = document.querySelector(targetId);
      var propInput = document.getElementById('purchase-prop-' + productId);

      // Toggle active class on li
      var list = this.closest('.ap-purchase-list') || this.closest('.btm1_list');
      if (list) {
        list.querySelectorAll('li').forEach(function (li) {
          li.classList.remove('active');
        });
        var parentLi = this.closest('li');
        if (parentLi) parentLi.classList.add('active');
      }

      // Update price display and hidden input
      if (val === 'subscribe') {
        if (propInput) propInput.value = 'Subscribe & Save (10% off)';
        if (target && price) {
          target.innerHTML = price + ' <span style="font-size:16px; color:var(--priColor, #a21710); font-weight:normal; display:inline-block; margin-left:6px;">(Save 10%)</span>';
        }
      } else {
        if (propInput) propInput.value = 'One-time purchase';
        if (target && price) {
          target.innerHTML = price;
        }
      }
    });
  });

  // AJAX add to cart for ap-cart-form
  var cartForms = document.querySelectorAll('.ap-cart-form, .btm1_cart_form');
  cartForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('button[type="submit"]');
      var originalText = submitBtn ? submitBtn.innerText : 'Add To Cart';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerText = 'Adding...';
      }

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Network error');
        }
        return response.json();
      })
      .then(function (item) {
        if (submitBtn) {
          submitBtn.innerText = 'Added to Cart!';
          setTimeout(function () {
            submitBtn.disabled = false;
            submitBtn.innerText = originalText;
          }, 2000);
        }
        if (typeof updateShopifyDetails === 'function') {
          updateShopifyDetails();
        }
      })
      .catch(function (error) {
        // Fallback to standard form submission
        form.submit();
      });
    });
  });
});
